import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import NotFound from './pages/NotFound';
import Dashboard from './pages/Dashboard';
import Category from "./pages/Category";
import Login from "./partials/Login";
import Register from "./partials/Register";
import Society from "./pages/Society";
import Staff from "./pages/Staff";
import Article from "./pages/Article";
import DetailArticle from "./pages/DetailArticle";
import DetailCategory from "./pages/DetailCategory";
import SearchItem from "./pages/SearchItem";
import Profile from "./pages/Profile";
import DetailTeam from "./pages/DetailTeam";
 
var permissions = JSON.parse(localStorage.getItem("permissions"))
? JSON.parse(localStorage.getItem("permissions"))
: [];
function handleCheck(val) {
    return  (permissions ?? []).some(item => val === item.name);
}

function RouterPage(){

    return(
        <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route path="/categories/:id" component={DetailCategory} />
            {
                handleCheck("afficher categorie") == true && (
                    <Route path="/cats" component={Category} />
                )
            }
            <Route path="/register" component={Register} />
            <Route path="/login" component={Login} />
            {
                handleCheck("configurer societe") == true && (
                    <Route path="/societies" component={Society} />
                )
            }
            
            {
                handleCheck("afficher utilisateur") == true && (
                    <Route path="/staffs" component={Staff} />
                )
            }
            
            {
                handleCheck("afficher article") == true && (
                    <Route path="/items" component={Article} />
                )
            }
            
            <Route path="/profile" component={Profile} />
            <Route path="/articles/search/:search" component={SearchItem} />
            <Route path="/articles/:id" component={DetailArticle} />
            <Route path="/teams/:id" component={DetailTeam} />
            <Route component={NotFound} />
        </Switch>
    )
}

export default RouterPage;